export const authTestIds = {
  loginForm: 'login-form',
  loginEmail: 'login-email',
  loginPassword: 'login-password',
  loginButton: 'login-button',
  loginError: 'login-error',
  forgotPasswordButton: 'forgot-password-button',
  loginRememberCheckbox: 'login-remember-checkbox',
  getResetLinkButton: 'get-reset-link-button',
  signInInstead: 'sign-in-instead',
  repeatPassword: 'repeat-password',
  submitButton: 'submit-button',
  dashboardCardTitle: 'dashboard-card-title',
};
